module.exports = __webpack_public_path__ + "img/Chevron-left-white-fat.1ee18e46.svg";